<!--  -->
<template>
  <div id="cameraTree">
    <el-scrollbar style="height: 95%">
      <el-input placeholder="输入关键字进行过滤" v-model="deviceName">
      </el-input>

      <el-tree
        class="filter-tree"
        :data="deviceData"
        default-expand-all
        highlight-current
        :check-on-click-node="checkOnClickNode"
        :show-checkbox="showCheckbox"
        :props="defaultProps"
        :filter-node-method="filterNode"
        @current-change="currentChange"
        ref="tree"
      >
        <!-- <span class="custom-tree-node" slot-scope="{ node }">
                  <i class="el-icon-document"></i>
                  <span class="node-title">{{ node.label }}</span>
                </span> -->
      </el-tree>
    </el-scrollbar>
  </div>
</template>

<script>
import { api } from "../api";
export default {
  props: {
    typeValue: {
      type: Number,
      default: null,
    },
    // deviceName: {
    //   type: String,
    //   default: "",
    // },
    showCheckbox: {
      // 是否多选
      type: Boolean,
      default: () => {
        return false;
      },
    },
  },
  data() {
    return {
      deviceName: "",
      deviceData: [],
      defaultProps: {
        children: "children",
        label: "name",
      },
      checkOnClickNode: true, // 默认点击选中。
    };
  },

  components: {},

  computed: {},

  mounted() {
    this.queryControlTaskCamera();
  },
  watch: {
    deviceName(val) {
      this.$refs.tree.filter(val);
    },
    typeValue(newVal, oldVal) {
      if (newVal) {
        this.queryControlTaskCamera(newVal);
      }
    },
  },
  methods: {
    currentChange(data) {
      this.$emit("currentChange", data);
      console.log(data, "=========");
    },
    queryControlTaskCamera(type) {
      let params = {
        deviceName: this.deviceName,
        controlType: type ? type : this.typeValue,
      };
      this.$fetch(
        "/vas/controltask/queryControlTaskCameraTree.json",
        params
      ).then((res) => {
        if (res.success) {
          this.deviceData = res.returnObj;
        }
      });
    },
    //递归树结构
    // menusDataPro(data) {
    //   const self = this;
    //   const result = [];
    //   if (data !== null) {
    //     data.forEach(function (item) {
    //       const entity = {};
    //       entity.id = item.securityWorkGroupCode;
    //       entity.name = item.securityWorkGroupName;
    //       entity.isLeaf = !item.hasLeaf || !item.securityWorkGroupChildren;
    //       if (
    //         item.securityWorkGroupChildren &&
    //         item.securityWorkGroupChildren.length > 0
    //       ) {
    //         entity.children = self.menusDataPro(item.securityWorkGroupChildren);
    //       }
    //       result.push(entity);
    //     });
    //     return result;
    //   }
    // },
    filterNode(value, data) {
      if (!value) return true;
      return data.name.indexOf(value) !== -1;
    },
  },
};
</script>
<style lang='scss' scoped>
#cameraTree {
  height: 380px;
  .filter-tree {
    margin-bottom: 10px;
  }
}
</style>
